export default __webpack_public_path__ + "static/media/feature-team_tab_1.fc54f307ce5f829dd930289247bcef11.svg";